<template>
  <div class="component-product-screenshots-list" style="direction: ltr;" itemscope itemtype="http://schema.org/MobileApplication">
    <Carousel
     :rtl="$store.getters['tenantConfig/isRTL']"
     :auto-width="true"
     :margin="8"
     :loop="true"
     :rewind="true"
     :items="12"
     :dots="false">
    <div style="width: 320px;" v-for="(screenshotUrl, index) in screenshotUrls" :key="index" class="card">
        <img  :src="fileUrl(screenshotUrl)" @click="screenshotClicked(index)" itemprop="screenshot">
    </div>
   </Carousel>
  </div>
</template>

<style>
.owl-item {
  padding-bottom: 5px;
}
</style>
<script>
import { mapGetters } from 'vuex'
import Carousel from '@/components/Carousel.vue'

export default {
  name: 'ProductScreenshotsList',
  components: {
    Carousel
  },
  props: {
    screenshotUrls: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isLoading: false,
      selectedScreenShotUrl: '',
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    })
  },
  watch: {
    screenshotUrls: function () {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 100)
    }
  },
  mounted () {
  },
  methods: {
    screenshotClicked (index) {
      this.$emit('click', index)
    }
  }
}
</script>
